import React from 'react';

import { useFormContext } from 'react-hook-form';

import { LbRadioGroup, InfoBox } from '@infoods/lifebase-ui';

import { MEALS_PER_DAY_OPTIONS } from '../../../../../../nutrition';

type MealsPerDayFormValues = { defaultMealsPerDay: number };

const MealsPerDay = () => {
  const { control } = useFormContext<MealsPerDayFormValues>();

  return (
    <InfoBox title="Choose the number of meals per day for the meal plan">
      <LbRadioGroup
        control={control}
        name="defaultMealsPerDay"
        options={MEALS_PER_DAY_OPTIONS}
        row
      />
    </InfoBox>
  );
};

export { MealsPerDay, MealsPerDayFormValues };
